<script>import OtpInput from "./parts/input.svelte";
import { cfgToThemeCdnPath } from "@infinitro/config";
import { Verbiage, t } from "@infinitro/content";
import { ModalDialog, Status, closeThisModal, modalStack } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { Text } from "@infinitro/text";
import { derived } from "svelte/store";
const thisModal = ModalDialog.TotpVerify;
const modalIndex = derived(
  modalStack,
  ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal)
);
const isModalOpen = derived(modalIndex, ($modalIndex) => $modalIndex >= 0);
const zOverlay = derived(
  modalIndex,
  ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999
);
const payload = derived(
  modalStack,
  ($modalStack) => $modalStack.find((e) => e.modal === thisModal)?.data
);
let submitting = false;
let fatalError = false;
let status = void 0;
let valid = void 0;
const closeModal = () => {
  if ($payload?.onClose && typeof $payload.onClose === "function") {
    $payload.onClose();
  }
  closeThisModal(thisModal);
};
const handleOtpChange = async (otpCode) => {
  if ($payload?.onInputComplete && typeof $payload.onInputComplete === "function") {
    submitting = true;
    [valid, status] = await $payload.onInputComplete(otpCode);
    submitting = false;
    fatalError = status === Status.TOO_MANY_ATTEMPTS;
    return [valid, status];
  }
  console.error("onInputComplete is not a function");
  return [false, void 0];
};
</script>

{#if $isModalOpen}
	<Modal
		{closeModal}
		noAnimation={$payload?.noAnimation ?? false}
		title={$payload?.title ?? $t(Verbiage.totp_verify)}
		zIndexOverlay={$zOverlay}
		zIndexUnderlay={$zOverlay - 1}
	>
		<div class="content">
			<img
				src={cfgToThemeCdnPath('/totp-verify/illustration.svg')}
				alt={$t(Verbiage.illustration_alt, 'alts')}
			/>
			<p class="text">
				{`${$payload?.content ?? $t(Verbiage.verification_code)}`}
			</p>
			{#if fatalError}
				<Text type="body" textColor="error" customStyle="text-align: center; font-size: 14px;">
					{$t(Verbiage.too_many_attempts_please_try_again_later)}
				</Text>
			{/if}
			<OtpInput
				numInputs={$payload?.numInputs ?? 6}
				{handleOtpChange}
				label={$payload?.label ?? ''}
			/>
		</div>
	</Modal>
{/if}

<style>
	.content {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between
}
.content > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse))
}
	.text {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    text-align: center;
    font-size: 1.875rem;
    line-height: 2.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
</style>
